import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureModulesService } from '@spartacus/core';
import { map } from 'rxjs/operators';
import { COMMON_SEARCH_FEATURE } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class SearchModuleGuard implements CanActivate {
  constructor(private featureModulesService: FeatureModulesService) {}

  canActivate(): Observable<boolean> {
    return this.featureModulesService.resolveFeature(COMMON_SEARCH_FEATURE).pipe(map(() => true));
  }
}
